import React, { PureComponent } from "react";
// import { push } from "react-router-redux";
import _ from "i18n";

import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiWarningOutline
} from "react-icons/ti";
import { getMonthName } from "Utils";

import {
  RegressionIcon,
  ProgressionIcon,
  StatisticsIcon,
  UsersIcon,
  UserIcon
} from "../Common/Icons";
import { StandardLineChart } from "../Common/Charts/StandardLineChart";
import styles from "./CollaboratorSpace.local.scss";
import collaboratorServices from "../../services/CollaboratorServices";

import { CollaboratorPerformanceFetching } from "./CollaboratorSpaceLargeFrameFetching";
import { CollaboratorStatisticsFetching } from "./CollaboratorSpaceLargeFrameFetching";

const colors = ["#4695DB", "#CDDDEC", "#FFC43A"];

const options = [
  { icon: <UserIcon />, label: _("individual"), value: "individual" },
  {
    icon: <UsersIcon size={14} />,
    label: _("collective"),
    value: "collective"
  },
  { icon: <StatisticsIcon />, label: _("fudiciaire"), value: "organization" }
];

class CollaboratorSpaceLargeFrame extends PureComponent {
  //******************   Content Functions  **************//
  constructor(props) {
    super(props);

    let monthName = getMonthName(new Date().getMonth() + 1);
    this.state = {
      loadingStatistics: false,
      loadingPerformances: false,
      errorStatistics: false,
      errorPerformances: false,
      statistics: [],
      performances: [],
      month: monthName,
      filter: {
        format: "cumulated",
        status: "individual"
      },
      performancesFilterIsVisible: false,
      choosenOption: options[0]
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsidePerformancesFilter.bind(this)
    );
    this.fetchCollaboratorPerformances();
  }

  componentDidUpdate(prevProps, prevState) {
    const { date, period } = this.props;
    if (prevProps.date !== date || prevProps.period !== period) {
      this.fetchCollaboratorPerformances();
    }
  }

  fetchCollaboratorPerformances = () => {
    const { user, organization, period, date } = this.props;
    this.setState({
      loadingStatistics: true,
      loadingPerformances: true
    });

    collaboratorServices
      .getPerformanceFolderStatistics(user.uid, organization.id)
      .then(response => {
        this.setState({
          statistics: response,
          loadingStatistics: false
        });
      })
      .catch(error => {
        this.setState({ errorStatistics: true, loadingStatistics: false });
      });

    collaboratorServices
      .getPerformanceChartStatistics(
        organization.id,
        user.adminisId,
        user.uid,
        period,
        date
      )
      .then(response => {
        this.setState({
          performances: response,
          loadingPerformances: false
        });
      })
      .catch(error => {
        this.setState({ errorPerformances: false, loadingPerformances: false });
      });
  };

  setPerformancesWrapperRef(node) {
    this.performancesWrapperRef = node;
  }

  handleChangeMonthState = month => {
    this.setState({ month: month });
  };

  renderPerformanceSection = () => {
    let {
      performancesFilterIsVisible,
      loadingPerformances,
      errorPerformances,
      filter,
      month,
      performances,
      choosenOption
    } = this.state;

    let monthState =
      performances.length !== 0
        ? performances[filter.status][filter.format].filter(
            item => item.month === month
          )[0]
        : [];

    return (
      <div className={styles.block_2_frame_1}>
        <div className={styles.block_2_frame_1_header}>
          <div>
            <h3>{_("performances")}</h3>
            <div
              ref={this.setPerformancesWrapperRef.bind(this)}
              className={
                styles.customed_select +
                " " +
                (performancesFilterIsVisible
                  ? styles.customed_select_opened
                  : "")
              }
              style={{ width: 160, marginLeft: 140, position: "absolute" }}
            >
              <div className={styles.customed_select_header}>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: 75
                  }}
                >
                  {choosenOption.icon} <span>{choosenOption.label}</span>
                </span>
                <div className={styles.actions}>
                  <div>
                    <span
                      className={styles.action}
                      onClick={this.handleDisplayPerformancesFilter}
                    >
                      <TiArrowSortedDown />
                    </span>
                  </div>
                </div>
              </div>
              {performancesFilterIsVisible && (
                <div className={styles.customed_select_body}>
                  <div className={styles.customed_select_body_options}>
                    {options.map((item, index) => (
                      <div
                        key={index}
                        className={styles.customed_select_body_option}
                        onClick={() =>
                          this.handleSelectPerformancesFilter(item)
                        }
                      >
                        {_(item.icon)} {_(item.label)}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className={styles.explore_button}
            onClick={() => this.handeleExploreCollaboratorPerformances()}
          >
            {_("explorer")}
          </div>
        </div>
        <div className={styles.block_2_frame_1_body}>
          <div className={styles.tabs}>
            {["cumulated", "nonCumulated"].map((type, i) => {
              return (
                <div
                  key={i}
                  className={
                    styles.tab_badge +
                    " " +
                    (filter.format === type ? styles.tab_badge_active : "")
                  }
                  onClick={() => this.handleSelectDataFormat(type)}
                >
                  {_(type)}
                </div>
              );
            })}
          </div>
          {loadingPerformances ? (
            <CollaboratorPerformanceFetching />
          ) : errorPerformances ? (
            <div className={styles.error_frame}>
              <TiWarningOutline />
              <span>Oups</span>
            </div>
          ) : (
            <div>
              {performances.length !== 0 && (
                <StandardLineChart
                  chartData={Object.values(
                    performances[filter.status][filter.format]
                  )}
                  dataKeysY={[
                    "effectiveBenchmark",
                    "normalizedBenchmark",
                    "budgetaryBenchmark"
                  ]}
                  dataKeyX={"month"}
                  legendLabels={[
                    _("effectiveBenchmark"),
                    _("normalizedBenchmark"),
                    _("budgetaryBenchmark")
                  ]}
                  month={month}
                  handleChangeMonthState={this.handleChangeMonthState}
                  containerHeight={270}
                  colors={colors}
                />
              )}
              {monthState.length !== 0 && (
                <div className={styles.frames}>
                  <div
                    key={"eb"}
                    className={styles.frame}
                    style={{ borderColor: colors[0] }}
                  >
                    <div
                      className={styles.dot}
                      style={{ background: colors[0] }}
                    />
                    <span>{_("effectiveBenchmark")}</span>
                    <span>{_(monthState.effectiveBenchmark)}</span>
                  </div>
                  <div
                    key={"nb"}
                    className={styles.frame}
                    style={{ borderColor: colors[1] }}
                  >
                    <div
                      className={styles.dot}
                      style={{ background: colors[1] }}
                    />
                    <span>{_("normalizedBenchmark")}</span>
                    <span>{_(monthState.normalizedBenchmark)}</span>
                  </div>
                  <div
                    key={"bb"}
                    className={styles.frame}
                    style={{ borderColor: colors[2] }}
                  >
                    <div
                      className={styles.dot}
                      style={{ background: colors[2] }}
                    />
                    <span>{_("budgetaryBenchmark")}</span>
                    <span>{_(monthState.budgetaryBenchmark)}</span>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  renderClientStatistics = () => {
    let { statistics, loadingStatistics, errorStatistics } = this.state;

    return (
      <div className={styles.block_2_frame_2}>
        {loadingStatistics ? (
          <CollaboratorStatisticsFetching />
        ) : errorStatistics ? (
          <div className={styles.error_frame}>
            <TiWarningOutline />
            <span>Oups</span>
          </div>
        ) : (
          statistics &&
          statistics.length > 0 &&
          statistics.map((element, index) => {
            return (
              <div className={styles.group_cellules} key={index}>
                {element.items.map((item, i) => {
                  return (
                    <div
                      className={styles.category_cellules}
                      key={`${index}-${i}`}
                    >
                      <div className={styles.cellules_header}>
                        {item.title === "top" ? (
                          <ProgressionIcon />
                        ) : (
                          <RegressionIcon />
                        )}
                        <h3>{_(item.title + "" + element.category)}</h3>
                      </div>
                      {item.children.map((child, k) => {
                        return (
                          <div
                            className={`${styles.cellule} ${
                              item.title === "top"
                                ? styles.cellule_top
                                : styles.cellule_flop
                            }`}
                            key={`${index}-${i}-${k}`}
                          >
                            <div className={styles.title}>
                              <span>{child.client}</span>
                              <span>{child.role}</span>
                            </div>
                            <div className={styles.points}>
                              {child.points} p
                            </div>
                            <div
                              className={`${styles.percentage} ${
                                item.title === "top" ? styles.top : styles.flop
                              }`}
                            >
                              {item.title === "top" ? (
                                <TiArrowSortedUp />
                              ) : (
                                <TiArrowSortedDown />
                              )}
                              <span>{child.percentage}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            );
          })
        )}
      </div>
    );
  };

  handleClickOutsidePerformancesFilter(event) {
    if (
      this.performancesWrapperRef &&
      !this.performancesWrapperRef.contains(event.target)
    ) {
      this.setState({ performancesFilterIsVisible: false });
    }
  }

  handleSelectPerformancesFilter = item => {
    let { loadingPerformances, errorPerformances } = this.state;
    if (loadingPerformances || errorPerformances) {
      return;
    }
    this.setState(state => {
      return {
        choosenOption: item,
        filter: { ...state.filter, status: item.value },
        performancesFilterIsVisible: false
      };
    });
  };

  handleDisplayPerformancesFilter = () => {
    let { loadingPerformances, errorPerformances } = this.state;
    if (loadingPerformances || errorPerformances) {
      return;
    }
    this.setState(state => {
      return {
        performancesFilterIsVisible: !state.performancesFilterIsVisible
      };
    });
  };

  handleSelectDataFormat = format => {
    let { loadingPerformances, errorPerformances } = this.state;
    if (loadingPerformances || errorPerformances) {
      return;
    }
    this.setState(state => {
      return {
        filter: { ...state.filter, format }
      };
    });
  };

  handeleExploreCollaboratorPerformances = () => {
    let { loadingPerformances, errorPerformances } = this.state;
    if (loadingPerformances || errorPerformances) {
      return;
    }
    return;
    // TODO Put the right direction
    // this.props.dispatch(push("/calendar"));
  };

  render() {
    return (
      <div className={styles.block_2}>
        {this.renderPerformanceSection()}
        {/* {this.renderClientStatistics()} */}
      </div>
    );
  }
}

export default CollaboratorSpaceLargeFrame;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpaceLargeFrame.js